import PropTypes from 'prop-types';
import { CAMPANHAS_DESIGN as D } from '../Campanhas.design';

/**
 * Barra segmentada de progresso de uma campanha.
 *
 * "Progresso" aqui e quao longe estamos do FIM do disparo, entao conta qualquer
 * estado terminal (enviado + erro + cancelado) — nao apenas sucesso. Uma campanha
 * onde tudo falhou esta 100% concluida e 0% bem-sucedida, e as duas informacoes
 * precisam aparecer.
 */
export default function CampanhaProgressoBar({ progresso, compacto = false }) {
    const p = progresso || {};
    const total = p.total || 0;

    // Campanha sem destinatarios e um caso real (a agregacao de contatos pode nao
    // achar ninguem). Sem esta guarda a divisao produziria NaN%.
    if (!total) {
        return <p className={D.progresso.vazio}>Sem destinatários</p>;
    }

    const enviado = p.enviado || 0;
    const erro = p.erro || 0;
    const cancelado = p.cancelado || 0;
    const concluidos = enviado + erro + cancelado;
    const pct = (n) => `${(n / total) * 100}%`;

    return (
        <div className="w-full">
            <div className={D.progresso.track}>
                <div className={D.progresso.segEnviado} style={{ width: pct(enviado) }} />
                <div className={D.progresso.segErro} style={{ width: pct(erro) }} />
                <div className={D.progresso.segCancelado} style={{ width: pct(cancelado) }} />
            </div>

            <p className={D.progresso.texto}>
                <span className={D.progresso.percentual}>{concluidos}</span>
                {`/${total} · ${Math.round((concluidos / total) * 100)}%`}
                {!compacto && erro > 0 && (
                    <span className="text-red-500 dark:text-red-400">{` · ${erro} ${erro === 1 ? 'falha' : 'falhas'}`}</span>
                )}
            </p>
        </div>
    );
}

CampanhaProgressoBar.propTypes = {
    progresso: PropTypes.shape({
        total: PropTypes.number,
        enviado: PropTypes.number,
        erro: PropTypes.number,
        cancelado: PropTypes.number,
    }),
    compacto: PropTypes.bool,
};
